/**
 * Matches the Season 1 competition name ("Season 1: <chosen name>"). The
 * trailing word boundary keeps "Season 10".."Season 19" out.
 */
export const SEASON_ONE_NAME_PATTERN = /season 1\b/i;

/** True when a competition name belongs to Season 1 (null-safe). */
export function isSeasonOneName(name: string | null | undefined): boolean {
  return SEASON_ONE_NAME_PATTERN.test(name ?? "");
}

/**
 * Matches any numbered season name ("Season 0: X", "Season 12"). A bridge
 * competition such as "Cozy Season" has no number and does not match.
 */
export const NUMBERED_SEASON_NAME_PATTERN = /\bseason \d+\b/i;

/** True when a competition name is a numbered season (null-safe). */
export function isNumberedSeasonName(name: string | null | undefined): boolean {
  return NUMBERED_SEASON_NAME_PATTERN.test(name ?? "");
}

/** Season 1 runs January 1 to 31, 2027 (decided 2026-10-28, confirmed 2026-11-01). */
export const SEASON_ONE_START_UTC = "2027-01-01T00:00:00Z";
/** First instant after the last Season 1 scoring day; teasers stop after this. */
export const SEASON_ONE_TEASER_UNTIL_UTC = "2027-02-01T00:00:00Z";
